import { UserProfile } from 'components/userProfile';

import { useConversationRow } from '../../../utils/useConversationRow';

import styles from './conversationsTableCustomer.module.scss';

/** Represents the content of the customer cell in the conversations table. */
export const ConversationsTableCustomer = (): JSX.Element => {
  const {
    conversationAndRequester: { conversation, requester },
  } = useConversationRow();
  const description = conversation.is_abandoned
    ? 'Abandoned'
    : conversation.attributes.subject;

  return (
    <UserProfile
      user={requester}
      truncateName
      description={description}
      descriptionClassName={styles.description}
    />
  );
};
